var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-spinner"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12","align":"center"}},[_c('b-spinner',{attrs:{"variant":"primary","type":"grow"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }